import { Component, OnInit } from '@angular/core';
import { MyauthService } from 'src/app/services/myauth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-verifyemail',
  templateUrl: './verifyemail.component.html',
  styleUrls: ['./verifyemail.component.css']
})
export class VerifyemailComponent implements OnInit {

  constructor(private myauth:MyauthService, private router: Router) {
    
   }

  ngOnInit(): void {
    setTimeout( fun =>{
      this.router.navigateByUrl('signin');
    }, 20000);
  }

}
